import { Component, h, Prop, Element } from '@stencil/core';
import { injectFont, injectCSS } from '../../utils';
import { TTextTag, TTextAlign, TTextWeight, TTextVariant, TTextColor } from './text-utils';
import { createStyles } from './text-styles';

@Component({
  tag: 'dc-ui-text',
  shadow: true,
})
export class DcUiText {
  @Element() el: HTMLElement;
  @Prop() tag: TTextTag = 'span';
  @Prop() textAlign?: TTextAlign = 'left';
  @Prop() weight?: TTextWeight; //@TODO: discuss to be removed
  @Prop() variant: TTextVariant = 'text';
  @Prop() color?: TTextColor = 'inherit';

  componentWillLoad() {
    injectFont();
  }

  render() {
    injectCSS(
      this.el,
      createStyles,
      this.tag,
      this.variant,
      this.color,
      this.textAlign,
      this.weight
    );

    return (
      <this.tag>
        <slot />
      </this.tag>
    );
  }
}
